__turbopack_context__.v({
  "className": "noto_sans_f815f8f7-module__aXlROa__className",
});
